import { render, staticRenderFns } from "./huovSendDocuHost.vue?vue&type=template&id=393ef9f4"
import script from "./huovSendDocuHost.vue?vue&type=script&lang=js"
export * from "./huovSendDocuHost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports